import { render } from "./Library.vue?vue&type=template&id=55897234"
import script from "./Library.vue?vue&type=script&lang=js"
export * from "./Library.vue?vue&type=script&lang=js"
script.render = render

export default script